import React from 'react';
import { Button, Table } from 'reactstrap';

import { Modal, ModalOpen, ModalClose } from '../Modal';

function SplitV2ErrorModalInit(data) {
	ModalOpen('SplitV2ErrorModal', data);
}

const valueOrDash = (v) => {
	if (v === null || v === undefined || v === '') return '-';
	return String(v);
};

const SplitV2ErrorModalContent = (props) => {
	if (!props) return null;

	return (
		<div className="ad_trade_bg p-4">
			<div className="modal-body">
				<Table striped bordered hover>
					<tbody>
						<tr>
							<td>Event</td>
							<td>{valueOrDash(props.SourceEventID)}</td>
						</tr>
						<tr>
							<td>Stock</td>
							<td>{valueOrDash(props.StockLabel)}</td>
						</tr>
						<tr>
							<td>Status</td>
							<td>{valueOrDash(props.Status)}</td>
						</tr>
						<tr>
							<td>Error code</td>
							<td>{valueOrDash(props.ErrorCode)}</td>
						</tr>
						<tr>
							<td>Error message</td>
							<td style={{ whiteSpace: 'pre-wrap' }}>{valueOrDash(props.ErrorMessage)}</td>
						</tr>
						<tr>
							<td>Needs manual review</td>
							<td>{props.NeedsManualReview ? 'yes' : 'no'}</td>
						</tr>
					</tbody>
				</Table>
			</div>
			<div className="modal-footer">
				<Button onClick={ModalClose} color="secondary">Close</Button>
			</div>
		</div>
	);
};

class SplitV2ErrorModal extends Modal {
	allow_close_via_ui() {
		return true;
	}

	mrender() {
		return <SplitV2ErrorModalContent {...this.props} />;
	}

	get_name() {
		return 'SplitV2ErrorModal';
	}

	get_fullscreen() {
		return false;
	}
}

export {
	SplitV2ErrorModalInit,
	SplitV2ErrorModal,
};



// WEBPACK FOOTER //
// ./src/c/SplitV2ErrorModal.js